import { HeatLossEstimateMethod } from '@/gql/graphql';

export const METHOD_DESCRIPTION: Record<HeatLossEstimateMethod, string> = {
  EPC_ENERGY_USE: "the energy consumption from the property's EPC",
  EPC_PROPERTY_TYPE: "the size and age from the property's EPC",
  CUSTOMER_ENERGY_USE: 'the energy consumption submitted by the Customer',
  CUSTOMER_PROPERTY_TYPE:
    'the size and age of the property submitted by the Customer',
};
